<template lang="pug">
  v-app.timeline-one-side
    bar-and-nav(v-model="navDrawer" :links="links" mini)
      scrollactive(:offset='80' highlight-first-item)
        nav-list(:items="items")
    v-main.main.w-100
      v-timeline.ml-4
        v-timeline-item(v-for="item in items" :key="item.slug" :id="item.slug" left)
          template(v-slot:opposite)
            .subtitle-2.text-left
              vue-markdown {{item.content}}
          v-card
            v-card-title
              h2.text-center.black--text.mb-0(style="width:100%") {{item.title}}
            v-card-text
              embed-frame(:url="item.embed" :width="embedWidth" :y-offset="37")
      v-footer(color="#005cb8")
        p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
import BarAndNav from '@/components/BarAndNav.vue'
import EmbedFrame from '@/components/EmbedFrame.vue'
import NavList from '@/components/NavList.vue'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    BarAndNav,
    EmbedFrame,
    NavList,
    VueMarkdown
  },
  props: {
    items: Array,
    links: Array
  },
  data: () => ({
    navDrawer: undefined
  }),
  computed: {
    embedWidth () {
      const NAV_WIDTH = 56
      const MARGIN = 16
      const DIVIDER = 96
      return (this.$vuetify.breakpoint.width - NAV_WIDTH - MARGIN - DIVIDER) * .7 - MARGIN * 2
    }
  }
}
</script>

<style lang="stylus">
.timeline-one-side
  .main
    position: absolute
  .v-timeline-item__opposite{
    max-width: 20%
  }
  .v-timeline {
    margin-right: -30%
  }
</style>